"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = exports.RightArrow = exports.LeftArrow = exports.ElseRightArrow = exports.ElseLeftArrow = exports.ArrowType = void 0;
var React = require("react");
var styles = require("../index.scss");
var ArrowType;
(function (ArrowType) {
    ArrowType["left"] = "left";
    ArrowType["right"] = "right";
})(ArrowType = exports.ArrowType || (exports.ArrowType = {}));
exports.ElseLeftArrow = function (props) {
    var onClick = props.onClick, _a = props.style, style = _a === void 0 ? {} : _a;
    return React.createElement("div", { className: styles.leftArrow, style: __assign({}, style), onClick: onClick });
};
exports.ElseRightArrow = function (props) {
    var onClick = props.onClick, _a = props.style, style = _a === void 0 ? {} : _a;
    return React.createElement("div", { className: styles.rightArrow, style: __assign({}, style), onClick: onClick });
};
exports.LeftArrow = function (props) {
    return React.createElement(exports.ElseLeftArrow, __assign({}, props));
};
exports.RightArrow = function (props) {
    return React.createElement(exports.ElseRightArrow, __assign({}, props));
};
exports.Arrow = function (props) {
    return props.type === ArrowType.left ? React.createElement(exports.LeftArrow, __assign({}, props)) : React.createElement(exports.RightArrow, __assign({}, props));
};
